/**
 * Calendar API service
 * Handles communication with the backend for calendar events
 */

import { apiGet } from './api';

export interface CalendarEventResponse {
	id: string;
	title: string;
	date: string;
	type: 'task' | 'project_milestone' | 'site_visit' | 'completion';
	project_id?: number;
	project_name?: string;
	project_company_name?: string | null;
	task_id?: number;
	site_visit_id?: number;
	color: string;
	status?: string;
	assigned_gardener_id?: number;
	gardener_name?: string;
}

/**
 * Get calendar events for a user
 */
export async function getCalendarEvents(params?: {
	user_id?: number;
	role?: string;
	start_date?: string;
	end_date?: string;
	scope?: 'self' | 'my_projects' | 'company' | 'all_companies';
}): Promise<CalendarEventResponse[]> {
	const queryParams = new URLSearchParams();
	if (params?.user_id) queryParams.append('user_id', params.user_id.toString());
	if (params?.role) queryParams.append('role', params.role);
	if (params?.start_date) queryParams.append('start_date', params.start_date);
	if (params?.end_date) queryParams.append('end_date', params.end_date);
	if (params?.scope) queryParams.append('scope', params.scope);
	
	const query = queryParams.toString();
	return apiGet<CalendarEventResponse[]>(`/calendar/events${query ? '?' + query : ''}`);
}


